import { PropType } from 'vue';
import mixins from 'vue-typed-mixins';

import InputableText from '@/components/inputableText/InputableText.vue';
import EditRowMixin from '@/entries/user/mixins/EditRowMixin';
import ElDatePickerMixin from '@/mixins/ElDatePickerMixin';
import InputableTextBaseMixin from '@/entries/user/mixins/InputableTextBaseMixin';
import { InputableTextMixin } from '@/components/inputableText/InputableText';

import { 役員借入ListItem } from '@/classes/service/分析計画/役員借入Service';

export default mixins(ElDatePickerMixin, EditRowMixin, InputableTextMixin, InputableTextBaseMixin).extend({
  name: 'C役員借入EditRow',

  components: {
    InputableText,
  },

  props: {
    editItem: {
      type: Object as PropType<役員借入ListItem>,
      required: true,
    },
  },

  methods: {
    changeCell(value: string | number, row: 役員借入ListItem, key: string): void {
      if (row != null) this.$set(row, key, Number(value));
    },
  },
});
